<template>
	<div class="px-5">
		<app-table
			class="mt-5 is-not-selectable"
			name="apps"
			:columns="columns"
			:current-page="currentPage"
			:last-page="lastPage"
			:rows="rows"
			@on-search-event="onSearch"
			@on-page="changePage"
		>
			<template slot="rows" slot-scope="props">
				<td
					class="is-not-selectable"
					v-show="showRow(columns, 1)"
				>
					{{ props.row.id }}
				</td>
				<td v-show="showRow(columns, 2)">
					{{ props.row.name }}
				</td>
				<td v-show="showRow(columns, 3)">
					{{ props.row.title }}
				</td>
				<td v-show="showRow(columns, 4)">
					{{ props.row.uri }}
				</td>
				<td v-show="showRow(columns, 5)">
					{{ props.row.numFragment }}
				</td>
				<td v-show="showRow(columns, 6)">
					{{ props.row.position }}
				</td>
				<td>
					<app-tooltip-button
						color="green"
						icon="edit"
						text="Editar Recurso"
						@click-icon="edit(props.row)"
					/>
					<app-tooltip-button
						color="red"
						icon="delete"
						text="Eliminar Recurso"
						@click-icon="openModalConfirmation(props.row)"
					/>
					<app-tooltip-button
						color="blue"
						icon="touch_app"
						text="Barra de Acciones"
						@click-icon="openActions(props.row)"
					/>
				</td>
			</template>
		</app-table>
		<app-confirmation-modal
			:loading="loading"
			:show-modal="modalConfirmation.value"
			@cancel="cancelModalConfirmation"
			@confirm="confirm()"
		/>
	</div>
</template>

<script>
import appConfirmationModal from '@/components/shared/app-confirmation-modal';
import appTooltipButton from '@/components/shared/app-tooltip-button';

function changePage(page) {
	this.$emit('change-page', page);
}

function confirm() {
	this.loading = true;
	this.$http
		.delete(`resource/${this.modalConfirmation.selectedRow.id}`)
		.then(() => {
			this.showNotification('Registro eliminado correctamente');
			this.modalConfirmation.value = false;
			this.$emit('on-delete');
		})
		.finally(() => {
			this.loading = false;
		});
}

function edit({ id }) {
	this.goTo('page-update-resource-edit', { params: { id, moduleId: this.moduleId, moduleName: this.moduleName } });
}

function onSearch(value) {
	this.$emit('on-search', value);
}

function openActions({ id, name }) {
	this.goTo('page-resource-action', { params: { id, codeProject: this.codeProject, name } });
}

function data() {
	return {
		loading: false,
	};
}

export default {
	name: 'resource-list',
	components: {
		appConfirmationModal,
		appTooltipButton,
	},
	data,
	props: {
		codeProject: {
			type: String,
			required: true,
		},
		columns: {
			type: Array,
			required: true,
		},
		currentPage: {
			type: Number,
			default: 0,
		},
		moduleId: {
			type: [Number, String],
			required: true,
		},
		moduleName: {
			type: String,
			required: true,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		rows: {
			type: Array,
			required: true,
		},
	},
	methods: {
		changePage,
		confirm,
		edit,
		onSearch,
		openActions,
	},
};
</script>



// WEBPACK FOOTER //
// src/components/resources/resource-list.vue